import { gql } from 'apollo-angular';
import { userItemFragment } from '../user/shared-user.fragments';

export const notificationItemFragment = gql`
  fragment NotificationItem on Notification {
    id
    title
    description
    time
    source
    causeUser {
      ...UserItem
    }
    createdAt
    readAt
    subject {
      id
    }
    contentType
  }
  ${userItemFragment}
`;
